/** Trip type values stored in DB */
export const TRIP_TYPES = {
  SINGLE: 'one_way',
  ROUND: 'round_trip',
  MULTI_STOP: 'multi_stop',
  DAILY: 'daily_recurring',
} as const;

export const TRIP_TYPE_OPTIONS = [
  { label: 'Single Trip', value: TRIP_TYPES.SINGLE },
  { label: 'Round Trip', value: TRIP_TYPES.ROUND },
  { label: 'Multi-stop Trip', value: TRIP_TYPES.MULTI_STOP },
  { label: 'Daily (Recurring) Trip', value: TRIP_TYPES.DAILY },
];

export const TRIP_TYPE_LABELS: Record<string, string> = {
  one_way: 'Single Trip',
  round_trip: 'Round Trip',
  multi_stop: 'Multi-stop Trip',
  multi_location: 'Multi-stop Trip',
  daily_recurring: 'Daily (Recurring)',
};

export const MULTI_STOP_TYPES = new Set([TRIP_TYPES.MULTI_STOP, 'multi_location']);

export const TRIP_CAPABILITIES = [
  'Single Trip',
  'Round Trip',
  'Multi-stop Trip',
  'Daily (Recurring) Trip',
  'Lead → Trip auto conversion',
  'WhatsApp Business driver flow',
];
